import { showError } from "#app";

const throwError = (
  statusCode: number,
  statusMessage: string,
  message: string = "",
) => {
  throw showError({
    statusCode,
    statusMessage,
    message,
  });
};

/**
 * Re-throws a failed CMS fetch. Client errors (4xx; Directus reports a missing item as 403) become
 * the given "not found" error; upstream failures (5xx, timeouts, network errors) stay server errors,
 * so they don't show up as 404s.
 */
export const throwFetchError = (
  error: any,
  notFound: { statusCode: number; statusMessage: string },
) => {
  const statusCode = error?.response?.status || error?.statusCode;

  if (statusCode >= 400 && statusCode < 500) {
    throwError(notFound.statusCode, notFound.statusMessage, notFound.statusMessage);
  }
  throwError(statusCode >= 500 ? statusCode : 503, "Service Unavailable");
};

export default throwError;
